<template>
  <div class="logout-container">
    <div
      class="logout-icon"
      @click="$emit('show-dialog')"
      :style="{ transform: 'translateY(0)' }"
    >
      <svg class="icon">
        <use href="@/assets/iconset.svg#logout_compact" />
      </svg>
    </div>
  </div>
</template>

<script>
import { useAuth } from "@/firebase/useAuth";
import { ref } from "vue";

export default {
  name: "LogoutButton",
  emits: ["loggedOut", "show-dialog"],
  setup(props, { emit }) {
    const { logout } = useAuth();
    const showDialog = ref(false);

    function handleLogout() {
      emit("show-dialog");
    }

    return {
      handleLogout,
      showDialog,
    };
  },
};
</script>

<style scoped>
.logout-container {
  position: relative;
  isolation: isolate;
  z-index: 50;
}

.logout-confirmation-dialog {
  isolation: isolate;
  z-index: 1000;
}

.logout-icon {
  position: fixed;
  top: var(--space);
  left: var(--smallSpace);
  cursor: pointer;
  z-index: 50;
  background-color: var(--bg-main-dark);
  border-radius: 50%;
  transition: transform 0.3s ease;
  padding: 3px;
  display: flex;
}

.logout-icon:hover {
  transform: scale(1.1);
}

.logout-icon .icon {
  transform: translateX(-2px);
}
</style>
